import { Loader2 } from 'lucide-react';

import { cn } from '@/lib/cn';

export interface SpinnerProps {
  className?: string;
  /** Announced to screen readers; pass null for a purely decorative spinner. */
  label?: string | null;
  size?: 'sm' | 'md' | 'lg';
}

const SIZES = {
  sm: 'size-4',
  md: 'size-6',
  lg: 'size-8',
} as const;

export function Spinner({ className, label = 'Loading', size = 'md' }: SpinnerProps) {
  return (
    <span role={label ? 'status' : undefined} className={cn('inline-flex items-center', className)}>
      <Loader2
        className={cn('text-muted-foreground animate-spin', SIZES[size])}
        aria-hidden="true"
      />
      {label && <span className="sr-only">{label}</span>}
    </span>
  );
}
